import cookieCommons from 'common/cookieCommons';
import { MutationObserverOptions, useMutation } from 'react-query';
import { postCreateOrder } from '../../apis/tms/order.api';
import { PAYMENT_URL } from '../../configs/externalLink';
import {
  ICreateOrderPayload,
  ICreateOrderResponse,
} from '../../interfaces/order.interface';

const useCreateOrder = ({
  opt,
}: {
  opt?: Omit<
    MutationObserverOptions<
      ICreateOrderResponse,
      Error,
      ICreateOrderPayload,
      ICreateOrderResponse
    >,
    '_defaulted' | 'variables'
  >;
}) => {
  const mutationReturn = useMutation({
    ...opt,
    mutationFn: postCreateOrder,
  });

  const redirectToPaymentPage = (orderId: string) => {
    const tmsUserId = cookieCommons.getTmsUserId() || '';

    window.location.href = PAYMENT_URL({
      uid: tmsUserId,
      orderId,
      url: window.location.href, //course detail page url
    });
  };

  return {
    mutationReturn,
    redirectToPaymentPage,
  };
};

export default useCreateOrder;
